import { Plus } from 'lucide-react';
import styles from './fab.module.css';

type FabProps = {
  label: string;
  onClick: () => void;
};

const ICON_SIZE = 28;

/** The one primary action of a screen, floating above the content at the bottom right. */
export const Fab = ({ label, onClick }: FabProps) => (
  <button type="button" className={styles.fab} aria-label={label} onClick={onClick}>
    <Plus size={ICON_SIZE} />
  </button>
);
